/**
 * Placeholder page for Evaluation module.
 * Replace with real pages once the design is finalized.
 */

import { useTranslation } from "react-i18next";
import "./EvalPlaceholderPage.css";

interface Props {
  /** Which page this stands in for; its title is the page's breadcrumb label. */
  page: "metrics" | "settings";
  description?: string;
}

export default function EvalPlaceholderPage({ page, description }: Props) {
  const { t } = useTranslation("eval");
  return (
    <div className="eval-placeholder">
      <div className="eval-placeholder__card">
        <h1 className="eval-placeholder__title">{t(`crumbs.${page}`)}</h1>
        <p className="eval-placeholder__desc">
          {description || t("placeholder.body")}
        </p>
      </div>
    </div>
  );
}
